import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import styled from "@emotion/styled";

interface IProps {
  onSelectClear: () => void;
}

export function SelectedButton({ onSelectClear }: IProps) {
  // Its div with role not a button because its nested inside other button
  return (
    <StyledDiv
      role="button"
      onClick={e => {
        e.stopPropagation();
        onSelectClear();
      }}
    >
      <StyledIcon kind={MdsIconKind.Exit} />
    </StyledDiv>
  );
}

const StyledDiv = styled.div`
  border-radius: 100%;
  height: 16px;
  width: 16px;
  padding: 0;
  & .toggle-btn-icon {
    color: ${({ theme }) => theme.colors.text.emphasis};
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.background.button.toggle.toggledHover};
  }
`;

const StyledIcon = styled(MdsIcon)`
  color: ${({ theme }) => theme.colors.icon.emphasis};
`;
